// Generated by AIG Copilot - start
import { CommonModule, SlicePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import {
  AlertModule,
  CardModule,
  CheckboxModule,
  DropdownModule,
  RadioButtonModule,
  TooltipModule,
} from 'axis-components';
import { RequestService } from '../../../_services/request/request.service';
import { LimitType } from '../../../config/constants';
import { UimuiBaseStateComponent } from '../uimui-base-state.component';
import { BaseRules, Control, TextValues } from './arizona-model';
import { TruncateModule } from 'axis-components/truncate';

@Component({
  selector: 'app-arizona',
  standalone: true,
  imports: [
    CardModule,
    CheckboxModule,
    CommonModule,
    DropdownModule,
    ReactiveFormsModule,
    RadioButtonModule,
    AlertModule,
    SlicePipe,
    TruncateModule,
    TooltipModule,
  ],
  templateUrl: './arizona.component.html',
  styleUrl: './arizona.component.scss',
})
export class ArizonaComponent extends UimuiBaseStateComponent<
  BaseRules,
  TextValues
> {
  @Input() set formGroup(form: FormGroup | null) {
    if (form) {
      super.getJsonRuleFiles('arizona', form);
    }
  }
  @Input() set isReview(review: boolean) {
    if (review) {
      super.getJsonRuleFiles('arizona', null);
    }
  }
  constructor(private requestService: RequestService) {
    super();
  }
  
  protected override getLookupControlName(
    control: Control,
  ): string | undefined {
    const isUIM = control.formControlName.includes('UIM') || control.formControlName.includes('UnderInsured');
    const umdropdown = 'CombinedSingleLimit_Uninsured_DropDown';
    const uimdropdown = 'CombinedSingleLimit_UnderInsured_DropDown';
    return isUIM ? uimdropdown : umdropdown;
  }
 
  override setupHookForDropDownData(){
    this.setupHookForLiabilityDropDownData();
  }
  
  public getLiabilityLimit: string = '';
  override calculatePremium(c: Control) {
    let limitTypeKey;
    if (this.baseRulesService.selectionTypeKey === 'IndividualState') {
      limitTypeKey = LimitType.CombinedSingleLimit.replaceAll(' ', '');
    } else {
      return [];
    }

    const lookupDropDownControl = this.controls.find(
      (control) =>
        control.formControlName ===
        limitTypeKey + c.baseRuleKey.split('UMLimit')[1],
    );
    const premium =
      'premium' + c.baseRuleKey.split('UMLimit')[1].toLocaleLowerCase();

    let liabilityLimit = this.requestService
      .getLiabilityLimitForState('arizona')
      .split('.')[0];
      this.getLiabilityLimit = liabilityLimit;
    this.baseRulesService.pdfDataDump['arizona'] = {
      ...this.baseRulesService.pdfDataDump['arizona'],
      [premium]:
        lookupDropDownControl?.data[lookupDropDownControl?.data?.length - 1]
          ?.premium,
    };
    for (const item of lookupDropDownControl?.data) {
      if (
        this.baseRulesService.getNumberFromString(item.name) >=
        this.baseRulesService.getNumberFromString(liabilityLimit)
      ) {
        this.baseRulesService.pdfDataDump['arizona'] = {
          ...this.baseRulesService.pdfDataDump['arizona'],
          [premium]: item.premium,
        };
        return {
          id: item.id,
          name: liabilityLimit,
          premium: item.premium,
        };
      }
    }
    return {
      id: 1,
      name: liabilityLimit,
      premium:
        lookupDropDownControl?.data[lookupDropDownControl?.data?.length - 1]
          ?.premium,
    };
  }
}
